import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHistory, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const ClusterPdfApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const history = useHistory()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.CLUSTER_PDF}
      scope='cluster_office'
      envKey={apps[AppId.CLUSTER_PDF].runtimeEnvKey}
      entryPath='./ClusterOfficeApp'
      url={process.env.REACT_APP_CLUSTER_OFFICE_APP_DEV_PATH}
      cdnUrl={apps[AppId.CLUSTER_PDF].cdnUrl}
      hasFullHeight
      appName={apps[AppId.CLUSTER_PDF].name}
      appProps={{
        user,
        initialPath: apps[AppId.CLUSTER_PDF].path,
        appType: 'pdfs',
        defaultHistory: history,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { ClusterPdfApp }
